<template>
  <modal-template :id="id" :name="name" :showModal="showModal" v-on:hide-modal="close()">
    <template slot="modalContent">
      <v-tabs v-model="activeTab" grow fixed-tabs>
        <v-tab key="cards" ripple>Cards</v-tab>
        <v-tab key="params" ripple>Other Parameters</v-tab>

        <v-tab-item key="cards">
          <v-toolbar dense style="width: 50%;">
            <v-btn @click="previousStep" color="info" :disabled="stepNumber===1">Back</v-btn>
            <v-spacer></v-spacer>
            <span>{{ stepMessages[stepNumber-1] }}</span>
            <v-spacer></v-spacer>
            <v-btn @click="nextStep" color="info">Continue</v-btn>
          </v-toolbar>

          <div id="subheader" v-if="stepNumber===1">
            <v-data-table id="criteria-table" :items="getAllCriteriaCards" hide-actions class="elevation-5">
              <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
              <template slot="headers" slot-scope="props">
                <th class="text-xs-left column-wrap">Notation</th>
                <th class="text-xs-left column-wrap">Code</th>
                <th class="text-xs-left" style="width: 20%">Name</th>
                <th class="text-xs-left column-wrap">Scale Unit</th>
                <th class="text-xs-left column-wrap">Direction</th>
                <th class="text-xs-left" style="width: 30%">Description</th>
                <th class="text-xs-left column-wrap">Icon</th>
                <th style="width: 70px;"></th>
              </template>
              <template slot="items" slot-scope="props">
                <tr :id="'row-'+props.item['Notation']">
                  <td>
                    <v-text-field placeholder="Insert value" v-model="props.item['Notation']" hide-details></v-text-field>
                  </td>
                  <td>
                    <v-text-field placeholder="Insert value" v-model="props.item['Code']" hide-details></v-text-field>
                  </td>
                  <td>
                    <v-text-field placeholder="Insert value" v-model="props.item['Name']" hide-details></v-text-field>
                  </td>
                  <td>
                    <v-text-field placeholder="Insert value" v-model="props.item['Scale Unit']" hide-details></v-text-field>
                  </td>
                  <td>
                    <v-select :items="['Maximization', 'Minimization']" v-model="props.item['Direction']" hide-details>
                      {{ props.item['Direction'] }}
                    </v-select>
                  </td>
                  <td>
                    <v-textarea placeholder="Insert value" v-model="props.item['Description']" hide-details rows="1" maxlength="150"></v-textarea>
                  </td>
                  <td @click="showIconPicker=true; clickedIcon=props.item" style="cursor: pointer;">
                    <v-icon color="black">{{ props.item['Icon'] }}</v-icon>
                  </td>
                  <td><v-btn icon @click="removeCriteriaLine(props.item)"><v-icon color="pink">delete</v-icon></v-btn></td>
                </tr>
              </template>
            </v-data-table>
            <v-btn @click="addCriteriaLine(null)" color="info">New Criterion</v-btn>
            <material-icon-picker :showModal="showIconPicker" v-on:picked-icon="applyIcon" v-on:hide-modal="showIconPicker=false"></material-icon-picker>
          </div>

          <div id="subheader" v-if="stepNumber===2 || stepNumber===3">     
            <div id="subsubheader" v-show="stepNumber === 2">
              Criteria Cards
              <div>
                <v-card class="v-card-container elevation-5">
                  <Container
                    id="criteria-container"
                    class="drag-container v-card-container"
                    group-name="cards"
                    orientation="horizontal"
                    :get-child-payload="getChildPayloadCriteria"
                    @drop="onCardDrop('criteria', $event)"
                  >
                    <Draggable class="drag-wrapper" v-for="card in getCriteriaCards(-1)" :key="card['ID']">
                      <v-tooltip bottom>
                        <v-card slot="activator" class="drag-item elevation-5 white--text" color="light-blue darken-4">
                          <div @click="showCardInfo(card)" style="height: 100%;">
                            <p></p>
                            <p v-if="card['Notation']">{{ card['Notation'] }}</p><p v-else>&nbsp;</p>
                            <p v-if="card['Code']">{{ card['Code'] }}</p><p v-else>&nbsp;</p>
                            <v-icon color="white">{{ card['Icon'] }}</v-icon>
                          </div>
                        </v-card>
                        <span>{{ card['Name'] }}</span>
                      </v-tooltip>
                    </Draggable>
                  </Container>
                </v-card>
              </div>
            </div>
            
            <div id="subsubheader" v-show="stepNumber === 3">
              Blank Cards
              <div>
                <v-card class="v-card-container elevation-5">
                  <Container
                    id="blank-container"
                    class="drag-container"
                    group-name="cards"
                    orientation="horizontal"
                    :get-child-payload="getChildPayloadBlank"
                    @drop="onCardDrop('blank', $event)"
                  >
                    <v-card class="drag-item elevation-5 white--text" style="position:absolute; left: calc(50% - 40px); top: 5px;" color="white"></v-card>
                    <v-card class="drag-item white--text" style="position:absolute; left: calc(50% - 41px); top: 4px;" color="white"></v-card>
                    <v-card class="drag-item white--text" style="position:absolute; left: calc(50% - 42px); top: 3px;" color="white"></v-card>
                    <v-card class="drag-item white--text" style="position:absolute; left: calc(50% - 43px); top: 2px;" color="white"></v-card>
                    <v-card class="drag-item white--text" style="position:absolute; left: calc(50% - 44px); top: 1px;" color="white"></v-card>
                    <Draggable class="drag-wrapper">
                      <v-tooltip bottom>
                        
                        <v-card slot="activator" class="drag-item white--text" color="white"></v-card>
                        <span>Blank Card</span>
                      </v-tooltip>
                    </Draggable>
                  </Container>
                </v-card>
              </div>
            </div>
            
            <p id="container-caption">Most Important</p>
            <div id="subsubheader" v-for="i in ranking" :key="i">
              <div>
                <v-card class="v-card-container elevation-5">
                  <Container
                    id="ranking-container"
                    class="drag-container v-card-container"
                    group-name="cards"
                    orientation="horizontal"
                    :get-child-payload="(index) => getChildPayloadRankings(index, i)"
                    @drop="onCardDrop(i, $event)"
                  >
                    <Draggable class="drag-wrapper" v-for="card in getCriteriaCards(i)" :key="card['ID']">
                      <v-tooltip bottom>
                        <v-card v-if="stepNumber===2" slot=activator class="drag-item elevation-5 white--text" color="light-blue darken-4">
                          <div @click="showCardInfo(card)" style="height: 100%;">
                            <p></p>
                            <p v-if="card['Notation']">{{ card['Notation'] }}</p><p v-else>&nbsp;</p>
                            <p v-if="card['Code']">{{ card['Code'] }}</p><p v-else>&nbsp;</p>
                            <v-icon color="white">{{ card['Icon'] }}</v-icon>
                          </div>
                        </v-card>
                        <v-card v-else slot=activator class="drag-item white--text" color="#708090">
                          <div>
                            <p></p>
                            <p v-if="card['Notation']">{{ card['Notation'] }}</p><p v-else>&nbsp;</p>
                            <p v-if="card['Code']">{{ card['Code'] }}</p><p v-else>&nbsp;</p>
                            <v-icon color="white">{{ card['Icon'] }}</v-icon>
                          </div>
                        </v-card>
                        <span>{{ card['Name'] }}</span>
                      </v-tooltip>
                    </Draggable>
                    <Draggable class="drag-wrapper" v-for="card in getBlankCards(i)" :key="card['ID']">
                      <v-tooltip bottom>
                        <v-card slot="activator" class="drag-item elevation-5 white--text"></v-card>
                        <span>Blank Card</span>
                      </v-tooltip>
                    </Draggable>
                  </Container>
                  <v-btn v-if="stepNumber===2 && i!==1 && i!==ranking" @click="removeRankingLevel(i)" color="pink" dark small absolute fab top right>
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn v-if="stepNumber===2" @click="addRankingLevel(i)" color="green" dark small absolute fab bottom left>
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-card>
              </div>
            </div>
            <p id="container-caption">Least Important</p>
          </div>
        </v-tab-item>

        <v-tab-item key="params">
          <div id="subheader">
            <v-text-field class="input-class" label="Ratio Z" v-model="ratioZ" type="number" @change="changedProp('ratioZ')" :rules="[rules.ratioZ]"></v-text-field>
            <v-select class="input-class" label="Decimal Places" v-model="decimalPlaces" :items="[0, 1, 2]" @change="changedProp('decimalPlaces')"></v-select>
            <v-select class="input-class" label="Weight Type" v-model="weightType" :items="['Non-Normalized', 'Normalized', 'Both']" @change="changedProp('weightType')"></v-select>
          </div>
        </v-tab-item>
      </v-tabs>
    </template>
  </modal-template>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import ModalTemplate from '@/components/Workspace/Methods/ModalTemplate'
import MaterialIconPicker from '@/components/Utils/MaterialIconPicker'
import {Container, Draggable} from "vue-smooth-dnd";
export default {
  components: {
    ModalTemplate, Container, Draggable, MaterialIconPicker
  },
  data: () => ({
    showModal: false,
    activeTab: null,
    tabs: ['cards', 'params'],

    lastId: 0,
    blankCard: {'Name': 'Blank', 'ID': null, 'Position': -1},

    cards: [],
    ratioZ: null,
    decimalPlaces: null,
    weightType: null,
    ranking: 2,

    stepMessages: ['Step 1: Creating criteria', 'Step 2: Ranking the cards', 'Step 3: Inserting blank cards'],
    stepNumber: 1,

    dirty: {},
    dataFromConnection: false,
    showIconPicker: false,
    clickedIcon: null,
    selected: null,

    rules: {
      ratioZ: value => parseFloat(value)>1 || 'Must be a real number greater than 1'
    }
  }),
  props: {
    id: String,
    name: String
  },
  methods: {
    clone(object) {
      return JSON.parse(JSON.stringify(object));
    },
    saveModuleData() {
      this.deleteUnusedRankingLevels();
      var headers = ['Notation', 'Code', 'Name'];
      if(this.weightType==='Non-Normalized' || this.weightType==='Both')
        headers.push('Non-Normalized Weight');
      if(this.weightType==='Normalized' || this.weightType==='Both')
        headers.push('Normalized Weight');
      var methodAttributes = {};
      methodAttributes.input = {
        cards: this.cards,
        ratioZ: [{'Ratio Z': this.ratioZ}],
        decimalPlaces: [{'Decimal Places': this.decimalPlaces}],
        weightType: [{'Weight Type': this.weightType}]
      };
      methodAttributes.output = {
        headers: headers,
        description: "Criteria Weight"
      };
      methodAttributes.id = this.id;
      EventBus.$emit('save-module-data', methodAttributes);
    },
    setPropertyFromInputFile(mod) {
      if(mod.newConnection) this.dataFromConnection = true;
      if(mod.property === 'cards') {
        this.cards = [];
        var highestPosition = 2;
        for(var element of mod.value) {
          if(element['Name'] !== 'Blank') {
            this.addCriteriaLine(element);
            if(element['Position']>highestPosition) 
              highestPosition = element['Position'];
          } else {
            element['Position'] = parseInt(element['Position']);
            this.cards.push(element);
          }
        }
        this.ranking = highestPosition;
        this.deleteUnusedRankingLevels();
        if(this.cards.some(c => c['Name'] === 'Blank')) this.stepNumber = 3;
        else if(this.cards.filter(c => c['Position'] !== -1).length > 0) this.stepNumber = 2;
        else this.stepNumber = 1;
      } else {
        var val = null;
        if(typeof mod.value !== 'undefined' && mod.value.length > 0)
          val = mod.value[0][Object.keys(mod.value[0])[0]];
        this[mod.property] = this.clone(val);
        if(!this.dataFromConnection && this[mod.property]!=null) this.checkIfDirty(mod.property)
      }
      if(typeof mod.value!=='undefined' && mod.value.length===0) this.dirty[mod.property] = false;
      else this.dirty[mod.property] = true;
      this.saveModuleData();
      if(mod.newConnection) this.dataFromConnection = false;
    },
    checkIfDirty(prop) {
      if(!this.dirty[prop]) {
        this.dirty[prop] = true;
        var offset = ['cards', 'ratioZ', 'decimalPlaces', 'weightType'].indexOf(prop);
        var valueAdapter = this[prop];
        if(offset!==0)
          valueAdapter = [[{'Ratio Z': this[prop]}], [{'Decimal Places': this[prop]}], [{'Weight Type': this[prop]}]][offset-1];
        var obj = {target: this.id, property: prop, value: valueAdapter, yOffset: offset};
        EventBus.$emit('generate-data-module', obj);
        return true;
      } else return false;
    },
    changedProp(prop) {
      if(!this.dataFromConnection) this.checkIfDirty(prop);
    },
    addCriteriaLine(line) {
      var newCrit = line ? line : {'ID': null, 'Name': ''};
      this.lastId += 1;
      newCrit['ID'] = this.lastId;
      if(!newCrit['Description']) newCrit['Description'] = '';
      if(!newCrit['Direction']) newCrit['Direction'] = 'Maximization';
      if(!newCrit['Position']) newCrit['Position'] = -1;
      else newCrit['Position'] = parseInt(newCrit['Position']);
      this.cards.push(newCrit);
      if(!this.dataFromConnection) this.checkIfDirty('cards');
    },
    removeCriteriaLine(line) {
      var index = this.cards.indexOf(line);
      if(index > -1)
        this.cards.splice(index, 1);
    },
    getChildPayloadBlank(index) {
      return this.blankCard;
    },
    getChildPayloadCriteria(index) {
      return this.getCriteriaCards(-1)[index];
    },
    getChildPayloadRankings(index, i) {
      if(this.noBlankCards(i))
        return this.getCriteriaCards(i)[index];
      else if(this.noCriteriaCards(i))
        return this.getBlankCards(i)[index];
    },
    onCardDrop (containerId, dropResult) {
      const {removedIndex, addedIndex, payload} = dropResult;
      if(payload['Name']!=='Blank' && this.stepNumber===3) return;
      if(addedIndex === null) return;
      if(containerId === 'criteria') {
        dropResult.payload['Position'] = -1;
      } else if(containerId === 'blank') {
        dropResult.payload['Position'] = -1;
      } else {
        if(payload['Name'] === 'Blank' && this.noCriteriaCards(containerId)) {
          if(payload['Position']===-1) {
            var newBlank = {'Name': 'Blank', 'ID': null, 'Position': -1};
            this.lastId += 1;
            newBlank['ID'] = this.lastId;
            newBlank['Position'] = parseInt(containerId);
            this.cards.push(newBlank);
          } else
          dropResult.payload['Position'] = parseInt(containerId);
        } else if(payload['Name'] !== 'Blank')
          dropResult.payload['Position'] = parseInt(containerId);
      }
    },
    getCriteriaCards(index) {
      return this.cards.filter(function(c) {return c['Name'] !== 'Blank' && c['Position'] === index;});
    },
    getBlankCards(index) {
      return this.cards.filter(function(c) {return c['Name'] === 'Blank' && c['Position'] === index;});
    },
    noCriteriaCards(index) {
      if(this.getCriteriaCards(index).length>0) return false;
      return true;
    },
    noBlankCards(index) {
      if(this.getBlankCards(index).length>0) return false;
      return true;
    },
    addRankingLevel(index) {
      for(var i=this.ranking; i>index; i--) {
        var iCards = this.getCriteriaCards(i).concat(this.getBlankCards(i));
        for(var card of iCards)
          card['Position'] +=1;
      }
      this.ranking +=1;
    },
    removeRankingLevel(index) {
      var iCards = this.getCriteriaCards(index).concat(this.getBlankCards(index));
      for(var card of iCards)
        card['Position'] = -1;
      for(var i=index+1; i<=this.ranking; i++) {
        var iCards = this.getCriteriaCards(i).concat(this.getBlankCards(i));
        for(var card of iCards)
          card['Position'] -=1;
      }
      if(this.ranking>2) this.ranking -=1;
    },
    deleteUnusedRankingLevels() {
      for(var i=this.ranking; i >= 1; i--)
        if(this.noBlankCards(i) && this.noCriteriaCards(i))
          this.removeRankingLevel(i);
    },
    addAlternateRankingLevels() {
      var i = 1;
      while(i<this.ranking) {
        if(!this.noCriteriaCards(i)) this.addRankingLevel(i);
        i++;
      }
    },
    removeAllBlankCards() {
      for(var i=this.cards.length-1; i>=0; i--) {
        if(this.cards[i]['Name'] === 'Blank')
          this.removeCriteriaLine(this.cards[i]);
      }
      this.deleteUnusedRankingLevels();
    },
    previousStep() {
      this.stepNumber-=1;
      if(this.stepNumber === 2) this.removeAllBlankCards();
    },
    nextStep() {
      this.deleteUnusedRankingLevels();
      if(this.stepNumber===1) {
        for(var card of this.cards) {
          if(card['Code']===undefined || card['Code']===null || card['Code']==='')
            return;
          if(card['Name']===undefined || card['Name']===null || card['Name']==='')
            return;
        }
        if(this.selected) {
          var row = document.getElementById('row-'+this.selected['Notation']);
          row.classList.remove('selected');
        }
      } else if(this.stepNumber===2) {
        this.addAlternateRankingLevels();
      }
      if(this.stepNumber===3) this.activeTab = 1;
      else this.stepNumber+=1;
    },
    showCardInfo(card) {
      this.previousStep();
      setTimeout(() => {
        var row = document.getElementById('row-'+card['Notation']);
        row.classList.add('selected');
        this.selected = card;
      }, 100);
    },
    applyIcon(icon) {
      this.showIconPicker=false;
      this.clickedIcon['Icon']=icon;
    },
    close () {
      this.saveModuleData();
      this.showModal=false;
    }
  },
  computed: {
    getAllCriteriaCards: function () {
      return this.cards.filter(function(c) {return c['Name'] !== 'Blank';});
    },
  },
  mounted: function () {
    EventBus.$on('show-modal-'+this.id, tab => {
      this.showModal = true;
      this.activeTab = ['ratioZ', 'decimalPlaces', 'weightType'].includes(tab) ? 1 : 0;
    });
    EventBus.$on('update-module-'+this.id, mod => {
      this.setPropertyFromInputFile(mod);
    });
    this.saveModuleData();
  }
}
</script>

<style scoped>
  #subheader {
    margin: 20px;
    font-size: 30px;
    line-height: 1.5;
  }
  #subsubheader {
    margin: 20px;
    font-size: 20px;
    line-height: 1.5;
  }
  * {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px
  }
  table.v-table thead th {
    background-color: #f2f2f2;
    max-width: 150px;
    white-space: initial;
    word-wrap: break-word;
    color: #333333 !important;
    font-size: 13px;
    font-weight: bold;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
    border-bottom: 1px solid LightGray;
  }
  table.v-table tbody td {
    font-family: 'Roboto Mono', sans-serif !important;
    word-wrap: break-word;
    font-size: 12px;
    font-weight: normal;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
  }
  .v-input {
    font-size: 12px;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  .column-wrap {
    width: 1px;
    white-space: nowrap;
  }
  .v-card-container {
    width: 100%;
    height: 120px;
    background-color: #F0F8FF;
  }
  .drag-container {
    width: 100%;
    display: inline-block;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .drag-wrapper {
    position: relative;
    text-align: center;
    line-height: 10px;
  }
  .drag-item {
    display: block;
    margin: 10px;
    cursor: grab;
    width: 70px;
    height: 100px;
    overflow: hidden;
    font-size: 14px;
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  #container-caption {
    font-size: 14px;
    font-style: italic;
  }
  .input-class {
    width: 30%;
    position: relative;
    left: 35%;
  }
  .selected {
    background-color: #E5FFE5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Workspace/Methods/DCMSRFModal.vue